import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 2a7.5 7.5 0 0 1 5 13.09v6.752a.805.805 0 0 1-1.289.644L12 19.702l-3.711 2.784A.805.805 0 0 1 7 21.842L7 15.09A7.5 7.5 0 0 1 12 2zm0 2.415a5.085 5.085 0 1 0 0 10.17 5.085 5.085 0 0 0 0-10.17z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }